import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { toast } from "sonner";
import api, { apiError } from "../lib/api";
import { useLang } from "../lib/i18n";
import { TypeIcon, PriorityIcon, StatusPill } from "../components/work/workMeta";
import { Skeleton } from "../components/ui/skeleton";

function ItemRow({ i }) {
  const today = new Date().toISOString().slice(0, 10);
  return (
    <Link to={`/work/${i.key}`} className="flex items-center gap-2 px-3 py-2 text-sm hover:bg-secondary/50" data-testid={`my-work-row-${i.key}`}>
      <TypeIcon type={i.type} />
      <span className="text-xs text-muted-foreground w-16 shrink-0">{i.key}</span>
      <span className="flex-1 truncate">{i.title}</span>
      {i.is_blocked && <span className="text-[10px] text-[#991B1B] font-semibold">BLOCKED</span>}
      <StatusPill name={i.status_name} category={i.status_category} />
      <PriorityIcon priority={i.priority} />
      {i.due_date && <span className={`text-xs whitespace-nowrap ${i.due_date < today ? "text-[#991B1B] font-medium" : "text-muted-foreground"}`}>{i.due_date}</span>}
    </Link>
  );
}

export default function MyWork() {
  const { t } = useLang();
  const [data, setData] = useState(null);
  useEffect(() => { api.get("/work/my").then((r) => setData(r.data)).catch((e) => toast.error(apiError(e))); }, []);
  if (!data) return <Skeleton className="h-60 w-full" />;
  const groups = data.assigned.reduce((acc, i) => { (acc[i.project_key] ||= { name: i.project_name, items: [] }).items.push(i); return acc; }, {});
  return (
    <div className="space-y-8" data-testid="my-work-page">
      <div>
        <h1 className="font-heading text-2xl sm:text-3xl font-semibold tracking-tight">{t("myWorkPage")}</h1>
        <p className="text-sm text-muted-foreground mt-1">{data.assigned.length} {t("items")} {t("assignedToMe").toLowerCase()}</p>
      </div>
      {Object.entries(groups).map(([key, g]) => (
        <section key={key} className="apha-card" data-testid={`my-work-project-${key}`}>
          <div className="px-4 py-2.5 border-b flex items-center gap-2"><span className="font-heading font-semibold">{key}</span><span className="text-sm text-muted-foreground">{g.name}</span><span className="ml-auto text-xs text-muted-foreground">{g.items.length}</span></div>
          <div className="divide-y">{g.items.map((i) => <ItemRow key={i.id} i={i} />)}</div>
        </section>
      ))}
      {data.assigned.length === 0 && <div className="apha-card p-6 text-sm text-muted-foreground" data-testid="my-work-empty">{t("noData")}</div>}
      {data.watching.length > 0 && (
        <section className="apha-card" data-testid="my-work-watching">
          <div className="px-4 py-2.5 border-b font-heading font-semibold">{t("watching")} ({data.watching.length})</div>
          <div className="divide-y">{data.watching.map((i) => <ItemRow key={i.id} i={i} />)}</div>
        </section>
      )}
    </div>
  );
}
